import React from "react";
import {Card, Icon} from "@vitalsource/vstui";
import createIcon from "../../../img/create.svg";
import createIconAnim from "../../../img/create.gif";
import importIcon from "../../../img/import.svg";
import importIconAnim from "../../../img/import.gif";
import comingSoon from "../../../img/coming_soon.svg";
import "../../../styles/AddProductWizard.css";
import ProductTypeCard from "./ProductTypeCard";
import {ProductCardType, ProjectConfigType} from "../../types/Types";
import {ExternalWindow as ExternalWindowSvg} from "@vitalsource/vstui-icons";
import styled from "styled-components";
import Svg from "react-inlinesvg";
import LinkWithGATracker from "../LinkWithGATracker"

const LearnMoreIcon = styled(Icon)`
  position: relative;
  top: 5px;
  left: 5px;
`;

export interface AddProductWizardProps {
  onProductTypeSelected: (type: ProductCardType) => void;
  projectConfig: ProjectConfigType
}

const getimportCardText = (allowXmlZipImport: boolean) => {
  return allowXmlZipImport ? "Import a PDF or XML" : "Import a PDF";
};

const getImportFileCard = (projectConfig: ProjectConfigType, onSelected: (type: ProductCardType) => void) => {

  if (projectConfig.allowPdfImport) {
    return (
      <ProductTypeCard
        icon={importIcon}
        hoverIcon={importIconAnim}
        onSelected={() => onSelected(ProductCardType.Import)}
        title={"Import"}
        description={<div>{getimportCardText(projectConfig.allowXmlZipImport)}<br/><LinkWithGATracker
            href={`${process.env.PUBLIC_URL}/support/StudioPDFImport.pdf`}
            className='import-content-message__link'
            onClick={(e: any) => {e.stopPropagation()}}
            target="_blank"><>Learn More</>
              <LearnMoreIcon height={16} width={16}><ExternalWindowSvg/></LearnMoreIcon>
            </LinkWithGATracker>
          </div>}
      />
    )
  } else {
    return (
      <Card className={"product-select__card"}>
        <div className={"product-select__button"}>
          <img src={importIcon}/>
          <Svg className={"product-select__coming-soon"} src={comingSoon}/>
          <h2 className={"product-select__title product-select__title--coming-soon"}>Import</h2>
          <p className={"product-select__desc"}>Import a PDF to create a new EPUB</p>
        </div>
      </Card>
    )
  }
};
const AddProductWizard = (props: AddProductWizardProps) => {
  return (
    <div className={"product-select"}>
      <ProductTypeCard
        icon={createIcon}
        hoverIcon={createIconAnim}
        onSelected={() => props.onProductTypeSelected(ProductCardType.EPUB)}
        title={"Create"}
        description={"Start a new EPUB"}
      />
      {getImportFileCard(props.projectConfig, props.onProductTypeSelected)}
    </div>
  )
};

export default AddProductWizard;
